module.exports = __webpack_public_path__ + "images/izibike48e5a60d409a508b1c0a6362a625f890.png";